import { axiosInstance } from '../axiosConfig';
import { handleRequestWithAuth } from '../refreshService';


const API_URL = 'category-public/';

export interface ApiCategory {
    id: number;
    nombre: string;
    descripcion: string;
    imagen: string | null;
    estado: boolean;
    fecha_creacion: string;
}

// Obtener SOLO categorías activas
export const fetchActiveCategories = async (): Promise<ApiCategory[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL, {
            params: { estado: true }
        });
        return response.data;
    });
};